import { SoundConstants } from "@lib/titan2-slingo/dist/game/view/abstract/constant/SoundConstants";
import { SoundManager } from "@lib/titan2/dist/game/manager/SoundManager";
/**
 * GameSoundConstants.ts
 */
export class GameSoundConstants extends SoundConstants {
    static getLevelUp(matchedPatterns) {
        const name = `PAYLADDER_INCREASE_${matchedPatterns}`;
        const properties = SoundManager.getInstance().getRegisteredSound(name);
        return properties;
    }
    static getDab(numberOfDabs) {
        return SoundManager.getInstance().getRegisteredSound(`DAB_SUCCESS_${numberOfDabs - 1}`);
    }
    static getBackground(matchedPatterns, isIdle = false) {
        if (isIdle) {
            return SoundManager.getInstance().getRegisteredSound("BACKGROUND_IDLE");
        }
        let properties;
        if (matchedPatterns >= 9) {
            properties = SoundManager.getInstance().getRegisteredSound("BACKGROUND_4");
        }
        else if (matchedPatterns >= 7) {
            properties = SoundManager.getInstance().getRegisteredSound("BACKGROUND_3");
        }
        else if (matchedPatterns >= 5) {
            properties = SoundManager.getInstance().getRegisteredSound("BACKGROUND_2");
        }
        else {
            properties = SoundManager.getInstance().getRegisteredSound("BACKGROUND_1");
        }
        return properties;
    }
}
GameSoundConstants.musicBlendTime = 0.333; // in seconds
//# sourceMappingURL=GameSoundConstants.js.map